import type { GetListParams } from "ra-core";

/**
 * BC records can belong to multiple segments via junction tables. List filters
 * use filter.sector (BC segment number) and must match any membership row.
 */
export async function applySegmentMembershipFilter(
  params: GetListParams,
  fetchRecordIds: (segmentNumber: string) => Promise<number[]>,
): Promise<GetListParams> {
  const filter = { ...(params.filter ?? {}) };
  const sector = filter.sector;
  if (sector == null || sector === "") {
    return params;
  }

  delete filter.sector;

  const recordIds = await fetchRecordIds(String(sector));
  const idFilter = recordIds.length > 0 ? `(${recordIds.join(",")})` : "(-1)";

  return {
    ...params,
    filter: {
      ...filter,
      "id@in": idFilter,
    },
  };
}

/** @deprecated Use applySegmentMembershipFilter */
export const applyCompanySectorFilter = applySegmentMembershipFilter;
